export default __webpack_public_path__ + "static/media/SettlementOn.d1e04ee2.svg";